import React from 'react';
import PropTypes from 'prop-types';

// import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import pushEvent, {
  EVENT_NOTIFY_POPUP_OPEN,
  EVENT_NOTIFY_POPUP_SUBSCRIBED,
  EVENT_NOTIFY_POPUP_CLOSED,
  EVENT_NOTIFY_POPUP_FILLED,
} from 'pushEvent';
import {
  NOTIFY_SUBSCRIBE_TICK_PERIOD,
  NOTIFY_WIDGET_POSITION,
} from 'store/common/notify/constants';

import SimpleNotifier from '../SimpleNotifier';
import { subscribeSessionCheck, stopCounter } from './helpers';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * The main reason of that component - it's specific logic of show/hide
 * during few sessions - so we have to use localStorage + timeouts for delayed show.
 * Also, it's logic is unique, and probably temporary, so it's incapsulated in component
 * to have a single point for the case, when it should be removed
 */
export default class SubscribeNotifier extends React.PureComponent {
  constructor(props) {
    super(props);
    const { isOpen } = props;
    this.state = {
      showNotifier: isOpen,
    };
  }

  componentDidMount() {
    const shouldShowNotifier = subscribeSessionCheck();
    const { showNotifier } = this.state;
    if (shouldShowNotifier && !showNotifier) {
      /* delayed action to render */
      setTimeout(this.openNotifier.bind(this), NOTIFY_SUBSCRIBE_TICK_PERIOD * 1000);
    }
    if (showNotifier) pushEvent(EVENT_NOTIFY_POPUP_OPEN);
  }

  openNotifier = () =>
    this.setState({ showNotifier: true }, () => {
      pushEvent(EVENT_NOTIFY_POPUP_OPEN);
    });

  render() {
    const { isMobile } = this.props;
    const { showNotifier } = this.state;

    return (
      showNotifier && (
        <SimpleNotifier
          widgetsProps={{
            onSubmitSubscribe: () => {
              stopCounter();
              pushEvent(EVENT_NOTIFY_POPUP_SUBSCRIBED);
            },
            onEmailValidate: () => {
              pushEvent(EVENT_NOTIFY_POPUP_FILLED);
            },
            widgetPosition: NOTIFY_WIDGET_POSITION,
          }}
          isOpen
          onClose={() => {
            pushEvent(EVENT_NOTIFY_POPUP_CLOSED);
          }}
          className={cx('subscribeNotify', { isMobile })}
          {...{ isMobile }}
        />
      )
    );
  }
}

SubscribeNotifier.propTypes = {
  isOpen: PropTypes.bool,
  isMobile: PropTypes.bool,
};

// const mapStateToProps = state => ({
//   notificationType: getNotificationType(state),
// });

// // const mapDispatchToProps = {
// //   getTypes: getDeviceTypes,
// //   selectOption: selectDeviceOption,
// // };

// export default connect(mapStateToProps)(NotifyTypeSwitcher);
